import React from 'react'
import {
  Container,
  Columns,
  Column,
  TextInput,
  Button,
} from '@resurs/midas-react'
import PropTypes from 'prop-types'
import Conditional from '@resurs/react-utils/lib/components/Conditional'
import Page from '../../internal/Page'
import { getText } from '../../internal/TextLabels'

const _isEmpty = bonusCheck =>
  !bonusCheck.reference &&
  !bonusCheck.amount &&
  !bonusCheck.validUntil &&
  !bonusCheck.status

const BonusChecksUI = ({
  searchCriteria,
  updateSearchCriteria,
  getBonusCheck,
  searchLoading,
  bonusCheck,
  redeemBonusCheck,
  searchButtonClicked,
  format,
}) => (
  <Container grid960>
    <Columns>
      <Column col1 colMd0 />
      <Column col10 colMd12>
        <Page title={getText('bonusChecks.title')}>
          <div style={{ marginBottom: '1rem' }}>
            <form
              onSubmit={e => {
                e.preventDefault()
              }}
            >
              <Container>
                <Columns>
                  <Column col6 colMd12>
                    <div
                      style={{
                        padding: '1rem',
                      }}
                    >
                      <TextInput
                        id="bonuschecks-search"
                        label={getText('bonusChecks.search.label')}
                        value={searchCriteria}
                        onChange={e => {
                          updateSearchCriteria(e.target.value)
                        }}
                        required={getText('default.form.required')}
                        format={format}
                        autoFocus
                      />
                    </div>
                  </Column>
                  <div
                    style={{
                      paddingTop: '4rem',
                      flexWidth: 30,
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Column>
                      <Button type="primary" onClick={getBonusCheck} form>
                        {getText('bonusChecks.search.button')}
                      </Button>
                    </Column>
                  </div>
                </Columns>
                <Conditional
                  when={
                    searchButtonClicked &&
                    !searchLoading &&
                    _isEmpty(bonusCheck)
                  }
                >
                  <div
                    style={{
                      color: 'red',
                      paddingLeft: '1rem',
                      marginBottom: '1rem',
                    }}
                  >
                    {getText('bonusChecks.searchFailed')}
                  </div>
                </Conditional>

                <Conditional
                  when={
                    !!bonusCheck &&
                    !!bonusCheck.reference &&
                    !!bonusCheck.reference.length > 0
                  }
                >
                  <Page>
                    <Container>
                      <Columns>
                        <Column col4>
                          <div style={{ paddingTop: '1rem' }}>
                            #{bonusCheck.reference}
                          </div>
                        </Column>

                        <Column col2>
                          <div style={{ paddingTop: '1rem' }}>
                            {bonusCheck.amount} {getText('bonusChecks.amount')}
                          </div>
                        </Column>

                        <Column col3>
                          <div style={{ paddingTop: '1rem' }}>
                            {getText('bonusChecks.validUntil')}{' '}
                            {bonusCheck.validUntil}
                          </div>
                        </Column>

                        <Column col3>
                          <Conditional when={bonusCheck.status === 'VALID'}>
                            <span
                              style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                              }}
                            >
                              <Button
                                type="primary"
                                kind="success"
                                onClick={redeemBonusCheck}
                              >
                                {getText('bonusChecks.redeem')}
                              </Button>
                            </span>
                          </Conditional>
                          <Conditional when={bonusCheck.status === 'REDEEMED'}>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                paddingBottom: '0.9rem',
                                paddingTop: '0.7rem',
                                color: 'red',
                              }}
                            >
                              {getText('bonusChecks.redeemedDate')}{' '}
                              {bonusCheck.redeemedDate}
                            </div>
                          </Conditional>
                          <Conditional when={bonusCheck.status === 'RESERVED'}>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                paddingBottom: '0.9rem',
                                paddingTop: '0.7rem',
                                color: 'red',
                              }}
                            >
                              {getText('bonusChecks.reservedDate')}{' '}
                              {bonusCheck.reservationValidUntil}
                            </div>
                          </Conditional>
                          <Conditional
                            when={
                              bonusCheck.status !== 'REDEEMED' &&
                              bonusCheck.status !== 'VALID' &&
                              bonusCheck.status !== 'RESERVED'
                            }
                          >
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                paddingBottom: '0.9rem',
                                paddingTop: '0.7rem',
                                color: 'red',
                              }}
                            >
                              {getText('bonusChecks.invalid')}
                            </div>
                          </Conditional>
                        </Column>
                      </Columns>
                    </Container>
                  </Page>
                </Conditional>
              </Container>
            </form>
          </div>
        </Page>
      </Column>
    </Columns>
  </Container>
)

BonusChecksUI.propTypes = {
  redeemBonusCheck: PropTypes.func.isRequired,
  getBonusCheck: PropTypes.func.isRequired,
  updateSearchCriteria: PropTypes.func.isRequired,
  searchCriteria: PropTypes.string,
  searchLoading: PropTypes.bool.isRequired,
  bonusCheck: PropTypes.object,
  searchButtonClicked: PropTypes.bool.isRequired,
}

BonusChecksUI.defaultProps = {
  bonusCheck: null,
  searchCriteria: '',
}

export default BonusChecksUI
